import { render, staticRenderFns } from "./FormDevTools.vue?vue&type=template&id=8708bffa&scoped=true&v-if=devTools&"
import script from "./FormDevTools.vue?vue&type=script&lang=js&"
export * from "./FormDevTools.vue?vue&type=script&lang=js&"
import style0 from "./FormDevTools.vue?vue&type=style&index=0&id=8708bffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8708bffa",
  null
  
)

export default component.exports